/**
 * <DOBPicker />
 *
 * @parent anybody
 * @stateful
 */
import React, { PropTypes } from 'react';
import classnames from 'classnames';
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';
import './DOBPicker.scss';

const DEFAULT_DATE = 'YYYY-MM-DD';

class DOBPicker extends React.Component {
  static propTypes = {

  }

  static defaultProps = {

  }

  constructor(props) {
    super(props);
  }

  render() {
    const {
      value,
      onChange,
      dateFormat = DEFAULT_DATE,
      placeholderText = DEFAULT_DATE,
      className
    } = this.props;

    let selected;

    if (value instanceof moment) {
      selected = value;
    } else if (typeof value === 'string' && value.length > 0) {
      selected = moment(value, dateFormat);
    } else {
      selected = value
    }

    return (
      <div className='dob-picker'>
        <DatePicker
          className={classnames('form-control ' + className)}
          selected={selected}
          onChange={onChange}
          dateFormat={dateFormat}
          showMonthDropdown
          placeholderText={placeholderText}
          showYearDropdown
          maxDate={moment()}
          yearDropdownItemNumber={50}
          scrollableYearDropdown />
      </div>
    )
  }
}

export default DOBPicker;



// WEBPACK FOOTER //
// ./src/components/UI/DOBPicker/index.js